import React, { useState } from 'react';
import Searchbar from "./Searchbar";
import { FiBell, FiChevronDown, FiMenu } from "react-icons/fi";
import { AuthUserI } from "../interfaces";

interface PropsI {
    isOnboarding?: boolean;
    toggleShowSidebar: () => void;
    user?: AuthUserI;
    logout?: () => void;
}

const Navbar = ({ isOnboarding, toggleShowSidebar, user, logout }: PropsI) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(true);

    const toggleDropdown = () => {
        // setIsDropdownOpen(!isDropdownOpen);
    };

    const closeDropdown = () => {
        setIsDropdownOpen(true);
    };

    return (
        <div className="navbar flex-end">
            <div className="nav-open-menu" onClick={toggleShowSidebar}>
                <FiMenu  />
            </div>
            <div className="nav-search">
                {/* {!isOnboarding ?
                    <Searchbar/>
                    : <></>
                } */}
            </div>
            {/* <div className="notification">
                <FiBell/>
                <div className="notification-indicator">
                    0
                </div>
            </div> */}
            <div className="flex items-center"onClick={toggleDropdown}>
                {/* <div className="nav-user" >
                    <div className="nav-user-text">
                        BP
                    </div>
                </div> */}
                <FiChevronDown className="text-2xl"/>
            </div>

            {isDropdownOpen && (
                    <div className="dropdown-menu" onClick={closeDropdown}>
                        <ul>
                            <li>
                                <button onClick={logout}>Logout</button>
                            </li>
                            {/* <li>
                                <a href="/my-profile">My Profile</a>
                            </li> */}
                        </ul>
                    </div>
                )}

        </div>
    );
}

export default Navbar;
